/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


export const areEqual = (lhs, rhs) =>
{
  if (lhs === rhs || (Number.isNaN(lhs) && Number.isNaN(rhs)))
  {
    return true;
  }

  if (lhs instanceof Date)
  {
    return rhs instanceof Date && lhs.getTime() === rhs.getTime();
  }

  return lhs?.equals?.(rhs) ?? false;
};


export const areDeepEqual = (lhs, rhs) =>
{
  if (areEqual(lhs, rhs))
  {
    return true;
  }

  if (lhs === null || rhs === null || typeof lhs !== 'object' || typeof rhs !== 'object')
  {
    return false;
  }

  if (lhs.deepEquals)
  {
    return lhs.deepEquals(rhs);
  }

  if (Array.isArray(lhs))
  {
    return Array.isArray(rhs) && lhs.length === rhs.length && lhs.every((value, index) =>
    {
      return areDeepEqual(value, rhs[index]);
    });
  }

  if (lhs.constructor !== Object || rhs.constructor !== Object)
  {
    return false;
  }

  const keys = Object.keys(lhs);

  return keys.length === Object.keys(rhs).length && keys.every(key =>
  {
    return areDeepEqual(lhs[key], rhs[key]);
  });
};


export const BasicComparator = (lhs, rhs) =>
{
  if (lhs.equals && lhs.less)
  {
    if (lhs.equals(rhs))
    {
      return 0;
    }

    return lhs.less(rhs) ? -1 : 1;
  }

  if (lhs === rhs)
  {
    return 0;
  }

  return lhs < rhs ? -1 : 1;
};

